const w = window;

module.exports = {

	storeUser: function(user) {
		w.User = user;
	},

	getUser: function() {
		return w.User;
	},

	getUserKey: function() {
		return  this.getUser() ? this.getUser().uid : null;
	},

	getUserEmail: function() {
		return  this.getUser() ? this.getUser().email : null;
	},

	isLoggedUser: function() {
		return this.getUser() ? true : false;
	},

	removeUser: function() {
		delete w.User;
	}
}


// WEBPACK FOOTER //
// ./src/helpers/AuthInfo/index.js